import { render } from "./Detail.vue?vue&type=template&id=fae7aa3a"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=fae7aa3a&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__